import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../store/modalSlice';
import Loading from '../Loading';

const TIMEOUT_MS = 10000;

const LazyLoadFallback = ({ onRetry }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setTimedOut(true), TIMEOUT_MS);
    return () => clearTimeout(id);
  }, []);

  if (!timedOut) {
    return <Loading size="small" minimal />;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(2px)',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t('loadingTakingLong', { defaultValue: 'Le chargement prend plus de temps que prévu.' })}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        {onRetry && (
          <Button variant="contained" size="small" onClick={onRetry}>
            {t('tryAgain')}
          </Button>
        )}
        <Button
          variant="outlined"
          size="small"
          onClick={() => dispatch(closeModal())}
        >
          {t('close')}
        </Button>
      </Box>
    </Box>
  );
};

export default LazyLoadFallback;
